import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { TitledPage } from '@client/new/components/Misc';
import { CircularProgress, Divider, TextField } from '@mui/material';
import { useSettingsViewModel } from './useSettings.viewModel';
import { FeatureSettings } from '@client/components/FeatureSettings';
import { SettingsPageCustomDomain } from '../creator/settings/domain/DomainSetup/SettingsPageCustomDomain';
import { colors } from '@client/new/components/colors';
import { PrimaryButton } from '@client/new/components/button';

type LiveStreamPageProps = {
  params: {
    influencerId: string;
  };
};

export const SettingsPage = (props: LiveStreamPageProps) => {
  const influencerId = parseInt(props.params.influencerId);
  const viewModel = useSettingsViewModel({ influencerId });

  return (
    <AsyncRenderer
      data={viewModel}
      loadRender={
        <TitledPage title="Settings">
          <div className="flex justify-center items-center">
            <CircularProgress />
          </div>
        </TitledPage>
      }
      renderer={(data) => (
        <TitledPage
          title="Settings"
          rightContent={
            data ? (
              <PrimaryButton
                onClick={() => data.dispatch({ type: 'submit' })}
                className="h-[40px]"
                disabled={data.submitting}
              >
                Save changes
              </PrimaryButton>
            ) : null
          }
        >
          <div className="bg-white flex flex-col rounded-xl p-8">
            <div>
              <p className="text-xl font-medium mb-4">Account Info</p>
              <div className="w-full">
                <span className="p-1 leading-5 text-sm font-medium">
                  Email <strong style={{ color: 'red' }}>*</strong>
                </span>
                <TextField
                  className="w-full"
                  placeholder="Your email"
                  {...data.register('email')}
                />
              </div>
            </div>
            {data.showFeatureSettings ? (
              <>
                <Divider
                  sx={{ marginY: '24px', borderColor: colors.neutral40 }}
                />
                <div>
                  <p className="text-xl font-medium mb-6">Feature Settings</p>
                  <div>
                    <FeatureSettings influencer={data.influencer} />
                  </div>
                </div>
              </>
            ) : null}
            <Divider sx={{ marginY: '24px', borderColor: colors.neutral40 }} />
            <div>
              <p className="text-xl font-medium mb-4">Custom Domains</p>
              <div>
                <SettingsPageCustomDomain influencerId={data.influencer.id} />
              </div>
            </div>
          </div>
        </TitledPage>
      )}
    />
  );
};
